import { videoRepository } from "../repository/VideoRepository";

export const videoService = {
  getVideoLink: async (onSuccess, onError) => {
    videoRepository
      .getVideo()
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  saveVideo: async (data, onSuccess, onError) => {
    videoRepository
      .saveVideo(data)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
};
